/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { CREATE_MASQ_BOX } from "../graphql/createMasqBox.mutation";
import { pretty } from "@vlinder-web/utils-react";

const is = require("is_js");
export interface ICreateMasqBoxArgs {
  presentationID: string;
  sectionID: string;
  firstName: string;
  lastName: string;
  email: string;
  partition: string;
  items: {
    costumeType: string;
    costumeFeature: string;
    costumeAttribute: string;
    costumeValue: string;
  }[];
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateMasqBoxTypeMethods extends IPluginMethodMap {
  createMasqBox(args: any): Promise<any>;
}

export class CreateMasqBoxService implements IAgentPlugin {
  readonly methods: ICreateMasqBoxTypeMethods;

  constructor() {
    this.methods = {
      createMasqBox: this.createMasqBox.bind(this),
    };
  }

  async createMasqBox(args: ICreateMasqBoxArgs) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: CREATE_MASQ_BOX,
          variables: {
            data: {
              presentation: args?.presentationID,
              section: args?.sectionID,
              partition: this.transformString(args?.partition),
              firstName: args?.firstName,
              lastName: args?.lastName,
              email: args?.email,
              items: args?.items,
            },
          },
          fetchPolicy: "no-cache",
        });

        if (res?.data?.createMasqBox && is.existy(res?.data?.createMasqBox)) {
          return res?.data?.createMasqBox;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  transformString(inputString: string) {
    const lowerCaseInput = inputString.toLowerCase();
    if (lowerCaseInput.includes("default")) {
      return "Default";
    } else if (lowerCaseInput.includes("special")) {
      return "SpecialReserve";
    } else if (lowerCaseInput.includes("sectionspecific")) {
      return "SectionSpecific";
    }
    return inputString;
  }
}
